import React, { useEffect, useRef, useState } from "react";
import { callPostApi } from "../../api/ApiCaller";
import { SET_GAME_BONUS_RESULT_POST } from "../../api/ApiConst";

let interactionDisabled = false;

function DiceBonus({ keyboardInput, gameSessionRecordId, onBonusRoundCompleted, gameResult }) {
    const boxesArr = [0, 1, 2, 3, 4];
    const [diceResult, setDiceResult] = useState(0);
    // const [currentIndex, setCurrentIndex] = useState(0);
    const [imageSrc, setImageSrc] = useState("./assets/img/DIceBonus/(0).png");
    const [selectedBoxes, setSelectedBoxes] = useState([]);
    const [gametotalWinSHow, setGametotalWinSHow] = useState(0);
    const startSoundRef = useRef(null);
    const endSoundRef = useRef(null);
    const intervalRef = useRef(null);
    const imageList = ["dice-1", "dice-2", "dice-3", "dice-4", "dice-5", "dice-6"];
    const keys = {
        "y": 0,
        "j": 1,
        "h": 2,
        "m": 3,
        "n": 4
    }




    
    useEffect(() => {
        let currentIndex = 0;
        intervalRef.current = setInterval(() => {
            currentIndex = currentIndex < 79 ? currentIndex + 1 : 0;
            setImageSrc(`./assets/img/DIceBonus/(${currentIndex}).webp`);
            return currentIndex;

        }, 30);

        return () => clearInterval(intervalRef.current);
    }, []);



    useEffect(() => {
        const handleKeyPress = (event) => {
            const key = event.key.toLowerCase();
            
            if (Object.keys(keys).includes(key)) {
                handleBoxClick(keys[key]);
            }
        };

        if (keyboardInput) {
            window.addEventListener("keydown", handleKeyPress);
            return () => {
                window.removeEventListener("keydown", handleKeyPress);
            };
        }


    }, [keyboardInput, gameSessionRecordId]);


    const handleSoundRoulette = () => {
        const winningDiv = document.getElementById("dice04-bonusAmount");

        if (startSoundRef.current) {
            let startSoundCount = 0;
            const startSoundInterval = setInterval(() => {
                if (startSoundCount < 2) {
                    toggleVisibility(winningDiv);
                    startSoundRef.current.play();
                    startSoundCount++;
                } else {
                    clearInterval(startSoundInterval);
                    resetSound(startSoundRef.current);
                }
            }, 1000);
        }

        if (endSoundRef.current) {
            setTimeout(() => {
                let endSoundCount = 0;
                const endSoundInterval = setInterval(() => {
                    if (endSoundCount < 2) {
                        toggleVisibility(winningDiv);
                        endSoundRef.current.play();
                        endSoundCount++;
                    } else {
                        clearInterval(endSoundInterval);
                        resetSound(endSoundRef.current);
                    }
                }, 1000);
            }, 2000);
        }
    };

    const toggleVisibility = (element) => {
        if (element) {
            element.classList.toggle("d-none");
            setTimeout(() => element.classList.toggle("d-none"), 200);
        }
    };

    const resetSound = (sound) => {
        sound.pause();
        sound.currentTime = 0;
    };


    const handleBoxClick = (boxId) => {
        if (interactionDisabled) return;
        if (selectedBoxes.includes(boxId)) return;
        interactionDisabled = true

        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }

        // Update selected boxes
        setSelectedBoxes((prevSelected) => [...prevSelected, boxId]);



        const clickedBox = document.getElementById(`diceWin-${boxId}`);
        const diceFirstSet = document.getElementById(`diceFirstAnim-${boxId}`);
        if (clickedBox) {
            diceFirstSet.classList.add("d-none");
        }

        const randomIndex = Math.floor(Math.random() * imageList.length);
        const randomImage = imageList[randomIndex];
        setImageSrc(`./assets/img/DIceBonus/${randomImage}.png`);

        const payload = {
            bonusType: "Bonus04Dice",
            recordId: gameSessionRecordId,
            tileNumber: boxId
        };



        callPostApi(SET_GAME_BONUS_RESULT_POST, payload, {}, (response) => {
            let res = response?.responsePacket;
            if (response?.errorCode === 0) {
                let gameDiceWin = res?.totalBonusWinnings;
                let gameTotal = res?.totalWinnings;
                setDiceResult(gameDiceWin);
                setTimeout(() => {
                    setGametotalWinSHow(gameTotal)
                }, 1500);

                const remainingBoxes = boxesArr.filter((box) => box !== boxId);
                remainingBoxes.forEach((box) => {
                    const boxElement = document.getElementById(box);
                    if (boxElement) {
                        boxElement.src = `./assets/img/DIceBonus/dice-3.png`;
                    }
                });
                setTimeout(() => {
                    handleSoundRoulette()
                }, 1000);

                // Restore the state after 2 seconds
                setTimeout(() => {
                    setSelectedBoxes((prevSelected) =>
                        prevSelected.filter((box) => box !== boxId)
                    );
                    if (clickedBox) {
                        clickedBox.src = `./assets/img/DIceBonus/dice-${gameDiceWin}.png`;
                        clickedBox.classList.remove("d-none");
                        clickedBox.classList.add("bottom-0");
                    }
                }, 1300);
                // sound code

                // show winning code
                if (gameTotal >= 0) {
                    setTimeout(() => {
                        if (onBonusRoundCompleted) {
                            onBonusRoundCompleted(gameTotal);
                            interactionDisabled = false
                        }
                    }, 7000);
                }
            } else {
                console.error("API Call Failed:", response?.errorMessage || "Unknown error");
            }
        });

    };


    const loadStaticAudio = () => {
        return (
            <>
                <div style={{ display: "none" }}>
                    <audio controls="" ref={endSoundRef} id="plopEndSound" className="audioFile">
                        <source src="assets/plop.wav" type="audio/mpeg" />
                    </audio>
                    <audio controls="" ref={startSoundRef} id="stakeStartSound" className="audioFile">
                        <source src="assets/stake.mp3" type="audio/mpeg" />
                    </audio>
                </div>
            </>
        );
    };
    return (
        <>
            <div className="h-100 w-100 position-relative">
                <img className="h-100 w-100" src="assets/img/DIceBonus/bg.png" alt="Background" />
                <div className="contentPosition p-0">
                    <div className="cauldron-content bg-transparent">
                        <div className="cauldron-inner-content">
                            <div className="text-center" style={{ height: "20%" }}>
                                <img className="w-100 h-100 " src="./assets/img/DIceBonus/header-bar.png" alt="Header" />
                            </div>
                            <div className="bg-black h-100">
                                <div className="container h-100">
                                    <div className="dice-row">
                                        {boxesArr.map((boxIndex) => (
                                            <div key={boxIndex} className="dice-col">
                                                <div
                                                    className="position-relative w-100 h-100 overflow-hidden"
                                                    onClick={() => {
                                                        if (!interactionDisabled) {
                                                            handleBoxClick(boxIndex);
                                                        }
                                                    }}
                                                >
                                                    <div
                                                        className={`cauldron-img-2${selectedBoxes.includes(boxIndex) ? "" : " d-none"
                                                            }`}
                                                    >
                                                        <img src={`assets/img/DIceBonus/dice.gif?v=${gameSessionRecordId + "-" + boxIndex}`} alt="Dice Animation" />
                                                    </div>
                                                    <img
                                                        id={`diceFirstAnim-${boxIndex}`}
                                                        className="dice-image"
                                                        src={imageSrc}
                                                        alt="Dice Animation"
                                                    />
                                                    <img
                                                        id={`diceWin-${boxIndex}`}
                                                        className="dice-image d-none"
                                                        src={`assets/img/DIceBonus/dice-${boxIndex + 1}`}
                                                        alt="Dice win"
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="cauldron-footer-content pt-2 diceFooter h-auto">
                        <div className="container-fluid">
                            <div className="score-board-block">
                                <div className="col-6">
                                    <h1>
                                        Escolha um dado para
                                        <br /> multiplicar seu prêmio:
                                    </h1>
                                </div>
                                <div className="col-6 ">
                                    <div className="d-flex justify-content-end">
                                        <div className="score-board-sec">
                                            <img src="./assets/img/DIceBonus/score-btn.png" alt="Score Button" />
                                            <span id="dice04-bonusAmount" className="text-content">{gametotalWinSHow ? gametotalWinSHow : gameResult.winnings}</span>
                                        </div>
                                    </div>
                                    <div className="score-board-content">Prêmio</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {loadStaticAudio()}
        </>
    );
}

export default DiceBonus;
